import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

// App-owned 24h time picker (HH / MM). Fully visible on narrow screens, no native-picker clipping.
// Emits "HH:MM" or "" when both cleared. Preserves the existing stored time format.
const HOURS = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, "0"));
const MINS = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, "0"));

export const TimeField = ({ value, onChange, testid }) => {
  const valid = value && /^\d{2}:\d{2}$/.test(value);
  const h = valid ? value.split(":")[0] : "";
  const m = valid ? value.split(":")[1] : "";
  const set = (nh, nm) => {
    if (!nh && !nm) return onChange("");
    onChange(`${nh || "00"}:${nm || "00"}`);
  };
  return (
    <div className="flex items-center gap-1.5 w-full min-w-0" data-testid={testid}>
      <Select value={h} onValueChange={(v) => set(v, m || "00")}>
        <SelectTrigger className="flex-1 min-w-0" data-testid={testid ? `${testid}-h` : undefined}>
          <SelectValue placeholder="HH" />
        </SelectTrigger>
        <SelectContent className="max-h-60">{HOURS.map((x) => <SelectItem key={x} value={x}>{x}</SelectItem>)}</SelectContent>
      </Select>
      <span className="font-bold text-muted-foreground">:</span>
      <Select value={m} onValueChange={(v) => set(h || "00", v)}>
        <SelectTrigger className="flex-1 min-w-0" data-testid={testid ? `${testid}-m` : undefined}>
          <SelectValue placeholder="MM" />
        </SelectTrigger>
        <SelectContent className="max-h-60">{MINS.map((x) => <SelectItem key={x} value={x}>{x}</SelectItem>)}</SelectContent>
      </Select>
    </div>
  );
};
